var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 36L-1.8947e-06 36L35 0L35 36Z",
    fill: "#EF4130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle3);
export default __webpack_public_path__ + "static/media/Triangle3.65b102eb3c6eff07dd72d4ba36f193cf.svg";
export { ForwardRef as ReactComponent };